import { useTranslation } from 'react-i18next';

import { Modal, type ModalProps } from '@app/shared/ui/organisms/Common';
import { SettlementBackground, SettlementImage } from '@app/shared/ui/molecules/Home';
import { Button, Heading } from '@app/shared/ui/atoms/Common';
import { FEED_XP_GAINED } from '@app/shared/constants/common';
import { pandaEatsCookiesImage } from '@app/assets';

type FeedPandaSuccessModalProps = Pick<ModalProps, 'isOpen' | 'onOpenChange'>;

export function FeedPandaSuccessModal({ isOpen, onOpenChange }: FeedPandaSuccessModalProps) {
  const { t } = useTranslation();

  const handleSuperBtnClick = () => {
    onOpenChange?.(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      contentClassName="bg-[#0A78E6BF]"
      hiddenTitle="Feed panda success"
    >
      <div className="flex flex-col gap-5 overflow-x-hidden">
        <div className="relative mx-auto mt-1 size-[105px]">
          <SettlementBackground />
          <SettlementImage
            imageUrl={pandaEatsCookiesImage}
            name="panda eats cookies"
            className="size-full"
          />
        </div>

        <div className="flex flex-col items-center">
          <Heading level={2} className="text-center font-bold">
            {t('home.feed_panda_success_modal.you_fed_panda')}
          </Heading>
          <Heading level={4} className="mt-2 text-center font-bold text-[#FFFFFFD6]">
            {t('home.feed_panda_success_modal.reward')}
          </Heading>
          <Heading level={2} className="text-center font-bold">
            +{FEED_XP_GAINED}XP
          </Heading>
        </div>

        <Button shadow="blue" onClick={handleSuperBtnClick}>
          {t('home.feed_panda_success_modal.super')}
        </Button>
      </div>
    </Modal>
  );
}
